import { format } from "lib/globalize-util";
import moment from "moment";

export const formatDateRange = (dateStart: string | Date, dateEnd: string | Date) => {
    const dateStartObject = dateStart ? moment(dateStart) : null;
    const dateEndObject = dateEnd ? moment(dateEnd) : null;

    if (!dateStartObject && !dateEndObject) {
        return "";
    }

    if (!dateStartObject) {
        return `${format("Till")} ${dateEndObject.format("MMM DD, YYYY")}`;
    }

    if (!dateEndObject) {
        return `${format("From")} ${dateStartObject.format("MMM DD, YYYY")}`;
    }

    if (dateStartObject.year() === dateEndObject.year()) {
        return `${dateStartObject.format("MMM DD")} - ${dateEndObject.format("MMM DD, YYYY")}`;
    }

    return `${dateStartObject.format("MMM DD, YYYY")} - ${dateEndObject.format("MMM DD, YYYY")}`;
};
